import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';

export default function FeedbackTakerLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login-feedback-taker', form);
      login(data.user, data.token);
      navigate('/feedback-taker/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="page flex-center" style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, rgb(255,46,88) 0%, rgb(59,28,98) 100%)',
        padding: '5vh 0vw',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
      }}>
        <img src={'https://pub-267dd4744ace49cf8306de8e7c530c15.r2.dev/assets/Logo-White.png'}
             style={{width: '40vw', minWidth: 150, maxWidth: 180, marginBottom: 40}}/>
        <div className="card" style={{ width: '100%', maxWidth: 420, background: 'rgba(255,255,255,0.12)', color: '#fff', borderColor: 'transparent' }}>
        <div className="text-center mb-3">
          <div style={{ fontSize: 40 }}>👤</div>
          <h2 style={{ marginTop: 8 }}>Staff Login</h2>
          <p style={{ fontSize: 14 }}>Sign in as a Feedback Taker</p>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label style={{color: '#fff'}}>Email</label>
            <input className="form-control" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required placeholder="staff@business.com" />
          </div>
          <div className="form-group">
            <label style={{color: '#fff'}}>Password</label>
            <input className="form-control" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required placeholder="••••••••" />
          </div>
          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
        <p className="text-center mt-2" style={{ fontSize: 14 }}>
          <Link to="/" style={{ color: '#fff', textDecoration: 'none' }}>←  Back to home</Link>
        </p>
      </div>
    </div>
  );
}
